// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__3JQiR","header":"PatientBlock_header__2ae1_","label":"PatientBlock_label__30TFP","option":"PatientBlock_option__Xp-Dh"};